import TableError from "./error"

function TableNoTableNodeError({ tableName, newTableName, message }) {
  TableError.call(this, `[tableName - ${tableName}, newTableName - ${newTableName}] ${message}`)
  this.name = "TableNoTableNodeError"
}

TableNoTableNodeError.prototype = Object.create(TableError.prototype)
TableNoTableNodeError.prototype.constructor = TableNoTableNodeError

export default TableNoTableNodeError
